import DirectDepositBenefitsScreen from 'features/directDepositBenefits/DirectDepositBenefitsScreen/DirectDepositBenefitsScreen';
import React from 'react';
import { PinwheelContextProvider } from 'shared/providers/pinwheel/PinwheelContextProvider/PinwheelContextProvider';

const DirectDepositBenefitsPage = () => {
  return (
    <PinwheelContextProvider>
      <DirectDepositBenefitsScreen />
    </PinwheelContextProvider>
  );
};

export default DirectDepositBenefitsPage;
